<script setup lang="ts">
import { computed, type HTMLAttributes } from "vue"
import { useLocation } from "~/composables/locations"
import { cn } from "~/lib/utils"

const { class: cl } = defineProps<{
    class?: HTMLAttributes["class"]
}>()

const { location } = useLocation()
const aboutContent = computed(() => location?.value?.pageContent?.about?.content as string | undefined)
const isLongContent = computed(() => {
    const totalLength = aboutContent?.value?.length || 0
    return totalLength > 500
})
</script>

<template>
    <section
        id="about"
        tabindex="-1"
        :class="cn('space-y-10 md:space-y-12', cl)"
    >
        <header class="text-center text-balance">
            <h2 class="text-2xl md:text-3xl">
                {{ location?.pageContent?.about?.title }}
            </h2>
        </header>
        <div
            class="text-center"
            role="article"
        >
            <p
                :class="cn(
                    isLongContent ? 'text-base' : 'text-xl',
                    'leading-loose md:leading-loose font-quote',
                )"
                v-html="aboutContent"
            />
        </div>
    </section>
</template>
